import axios from 'axios'

export default {
  all: () => axios.get(`/api/towns`).then(response => response.data),
  nonDismissed: () => axios.get(`/api/towns`,{ params: { "non-dismissed": true }}).then(response => response.data)
}
